import { Playground } from "docz";
import { Translator, TextFallback as Text } from "../../../../../docz/components";
import React from 'react';
export default {
  Playground,
  Translator,
  Text,
  React
};